var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"home"},[_vm._v("이 페이지는 babylonjs의 기능을 학습한 기록입니다.")])}
var staticRenderFns = []

export { render, staticRenderFns }